// Order lines are stored in their format (Cajas, Botellas, kg): that is what
// the WMS and Loken work with. People count units, so screens that edit a
// quantity take units and convert them back to the format.

import { formatCount, pluralFormat } from './loadingScan';

const round3 = (value) => Math.round(value * 1000) / 1000;

// Units a format holds ("Caja" de 12 → 12). null for kg lines and one-unit
// formats, where there is nothing to convert.
export const unitsPerFormat = (item) => {
  const perFormat = Number(item.format_quantity) || 1;
  if (item.format_unit_kg || perFormat <= 1) return null;
  return perFormat;
};

// A part of a format is kept with 3 decimals, so the units come back slightly
// off (13 of a 12-unit box: 1.083 → 12.996). Within that rounding they are the
// whole number the quantity was made of. Same rule as formatLineQuantity.
export const formatsToUnits = (item, formats) => {
  const perFormat = unitsPerFormat(item) || 1;
  const raw = (Number(formats) || 0) * perFormat;
  const whole = Math.round(raw);
  return Math.abs(raw - whole) <= perFormat * 0.0005 + 1e-9 ? whole : round3(raw);
};

export const unitsToFormats = (item, units) =>
  round3((Number(units) || 0) / (unitsPerFormat(item) || 1));

// "2 Cajas", "1.08 Cajas", "1.25 Kg".
export const describeFormats = (item, formats) => {
  const value = round3(Number(formats) || 0);
  if (item.format_unit_kg) return `${value} ${item.format_name || 'kg'}`;
  const name = value > 0 && value <= 1 ? item.format_name : pluralFormat(item.format_name);
  return `${formatCount(value)} ${name}`;
};

// "2 Cajas = 24 unidades", "2 Botellas", "1.25 Kg".
export const describeQuantity = (item, formats) => {
  const text = describeFormats(item, formats);
  if (!unitsPerFormat(item)) return text;
  const units = formatsToUnits(item, formats);
  return `${text} = ${units} ${units === 1 ? 'unidad' : 'unidades'}`;
};
